import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import SharePage from "./pages/SharePage"
import SupportPage from "./pages/Support"
import LandingPage from "./pages/LandingPage"

class Navigator extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path="/">
              <LandingPage />
            </Route>
            <Route path="/support">
              <SupportPage />
            </Route>
            <Route path="/job">
              <SharePage />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default Navigator





